import * as React from 'react'
import useReduxState from 'src/hooks/useReduxState'

const Header = () => {
    const [sortBy, setSortBy] = useReduxState('', 'articleSortBy')

    const onFilter = async (e) => {
        setSortBy(e.target.value)
    }

    return (
        <div className='all-content-header'>
            <div className="bs5 row mt-1">
                <div className="col-auto">
                    <div className='font-oswald font-light font-30'>VIDEOS </div>
                </div>
                <div className="col-auto ms-auto align-self-end">
                    <div className='d-flex align-items-center'>
                        <label className='mb-0 me-3'>Sort By:</label>
                        <div className="selectbox">
                            <select className="form-control form-control-xs w210" id="Customer"
                                onChange={(e) => onFilter(e)}>
                                <option value=''>Relevance</option>
                                <option value='asc'>Name - A to Z </option>
                                <option value='desc'>Name - Z to A</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header